import { scrollToTop } from "../utils/functions/scrollToTop";

export function setCartPage() {
  scrollToTop();
  return {
    type: 'SET_PAGE',
    pageName: 'cart',
  }
}

export function setOverviewPage() {
  scrollToTop();
  return {
    type: 'SET_PAGE',
    pageName: 'overview'
  };
}

export function setAdminPage() {
  scrollToTop();
  return {
    type: 'SET_PAGE',
    pageName: 'admin'
  };
}

export function setPageNumber(number) {
  scrollToTop();
  return {
    type: 'SET_PAGE_NUMBER',
    pageNumber: number
  }
}

export function setErrorPage(msg) {
  scrollToTop();
  return {
    type: 'SET_ERROR_PAGE',
    pageName: 'error',
    text: msg
  }
}

export function setDeltaErrorPage(msg) {
  scrollToTop();
  return {
    type: 'SET_DELTA_ERROR',
    pageName: 'error',
    text: msg
  }
}

export function refresh() {
  scrollToTop();
  return {
    type: 'REFRESH_PAGE',
    pageName: 'overview'
  }
}
